import styled, { css } from 'styled-components/macro'
import Grid from 'components/shared/Grid'
import { respondAbove } from 'styles/mediaQueries'

interface GalleryWrapperProps {
    hasAlternativeLayout?: boolean
}

export const GalleryWrapper = styled(Grid)<GalleryWrapperProps>`
    width: fit-content;
    max-width: 100%;
    margin: auto;
    justify-self: center;
    height: fit-content;

    //TODO: rewrite styling to fit any image into grid and alternative grid

    ${({ hasAlternativeLayout }) =>
        !hasAlternativeLayout &&
        css`
            max-width: 590px;
            max-height: 294px;
            grid-template-rows: 1fr;

            > :nth-child(1),
            > :nth-child(2) {
                display: none;
            }
        `}

    ${({ hasAlternativeLayout }) =>
        hasAlternativeLayout &&
        css`
            max-width: 690px;
            max-height: fit-content;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: auto 1fr;

            > :nth-child(1),
            > :nth-child(2) {
                display: initial;
            }
        `}

    > :nth-child(3) {
        background-position: right;
    }

    > :first-child {
        grid-area: 1 / 1 / span 1 / span 2;
    }

    @media ${respondAbove.md} {
        grid-template-columns: ${({ hasAlternativeLayout }) =>
            hasAlternativeLayout === true ? '440px 1fr' : '245px 1fr'};
        > :first-child {
            grid-area: 1 / 1 / span 2 / span 1;
            display: initial;
        }
        > :nth-child(2),
        > :nth-child(3) {
            display: initial;
            grid-column: 2 / span 2;
        }
    }
`
